var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDropup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B9B9B9",
    d: "M666.883,943.515c-91.787,0-241.983,0-333.77,0H113.816c-91.786,0-129.335-65.038-83.442-144.526 L140.025,609.07c45.894-79.489,120.99-209.564,166.885-289.055L416.557,130.1c45.895-79.488,120.99-79.488,166.883,0 l109.643,189.914c45.893,79.491,120.99,209.566,166.885,289.056l109.656,189.92c45.896,79.487,8.348,144.524-83.439,144.524 H666.883L666.883,943.515z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropup);
export default __webpack_public_path__ + "static/media/icon-dropup.f4300dda0e6070990c7e40c5f3235323.svg";
export { ForwardRef as ReactComponent };